import React from 'react';
import "./EliteButton.css";
import {useNavigate} from "react-router-dom";

function EliteButton() {
    const navigate = useNavigate();

    return (
        <div className="eliteButton" onClick={() => {
            navigate(`/oferta-elite`)
        }}>
            <span>Oferta Elite</span>
        </div>
    );
}

export default EliteButton;